module.exports = __webpack_public_path__ + "static/media/img_card@3x.6510cf05.png";